import { render } from "./Assistance.vue?vue&type=template&id=01cc349a"
import script from "./Assistance.vue?vue&type=script&lang=js"
export * from "./Assistance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Assistance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01cc349a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01cc349a', __exports__)) {
    api.reload('01cc349a', __exports__)
  }
  
  module.hot.accept("./Assistance.vue?vue&type=template&id=01cc349a", () => {
    api.rerender('01cc349a', render)
  })

}


export default __exports__